<script>
    import { page, modal } from '../store/nav';
    import { categories } from "../store/items";

    export let list_uid;
    export let name = '';

    const setCategory = (category) => {
        localStorage.setItem('new-ingredient-category',category);
        modal.open(`/new-item?list_uid=${list_uid}&category_uid=${category}&name=${name}&anchor=bottom`)};
</script>
<section class="flex flex-col space-y-7 h-96 overflow-auto no-scrollbar">
    {#each $categories as category}
        <section class="flex m h-16 text-primary" on:click={ () => setCategory(category) }>
            <div class="bg-primary rounded-2xl w-12 h-12"><img class="m-auto w-8 mt-2" src="/img/icon/food/{category}.png" alt=""></div>
            <span class="text-2xl ml-4 capitalize place-self-center">{category}</span>
        </section>
    {/each}
</section>